export const supportedProcessors = [
    {
        name: "stripe",
        title: "Stripe",
        logo: require("@/assets/images/logos/stripe.svg"),
        link: "https://stripe.com/",
    }
];
